import { PaymentStatus } from '../types';
import { setPaymentStatus, clearPaymentStatus, SetPaymentStatusAction, ClearPaymentStatusAction } from './actions';

const initialState: PaymentStatus = null;

function paymentStatusReducer(
	state = initialState,
	{ type, payload }: SetPaymentStatusAction | ClearPaymentStatusAction
) {
	switch (type) {
		case setPaymentStatus.toString():
			return payload;
		case clearPaymentStatus.toString():
			return initialState;
		default:
			return state;
	}
}

export default paymentStatusReducer;
